import React from "react";
import { Link } from "react-router-dom";
import { Users, Fuel, Snowflake, Cog } from "lucide-react";

export default function VehicleCard({ v, dark = true }) {
  const surface = dark ? "card-marketing" : "bg-white border border-black/5";
  const text = dark ? "text-white" : "text-[#0B1F3A]";
  const muted = dark ? "text-white/60" : "text-[#0B1F3A]/60";
  const backendOrigin = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const imgSrc = v.image_url?.startsWith("http") ? v.image_url : `${backendOrigin}${v.image_url}`;

  return (
    <div className={`${surface} overflow-hidden group flex flex-col`} data-testid={`vehicle-card-${v.id}`}>
      <div className="relative aspect-[16/10] overflow-hidden">
        <img src={imgSrc} alt={v.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="eyebrow bg-black/60 text-[#D4AF37] px-3 py-1 rounded-full">{v.category}</span>
          {!v.available && <span className="text-[10px] tracking-widest uppercase bg-red-500/90 text-white px-3 py-1 rounded-full">Unavailable</span>}
        </div>
      </div>
      <div className={`p-6 flex-1 flex flex-col ${text}`}>
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display font-bold text-xl tracking-tight">{v.name}</h3>
          <div className="text-right">
            <div className="text-2xl font-display font-extrabold text-[#D4AF37]">${v.daily_price}</div>
            <div className={`text-[10px] uppercase tracking-wider ${muted}`}>/ day</div>
          </div>
        </div>
        <div className={`grid grid-cols-2 gap-3 mt-5 text-sm ${muted}`}>
          <div className="flex items-center gap-2"><Users className="w-4 h-4 text-[#D4AF37]" />{v.passengers} seats</div>
          <div className="flex items-center gap-2"><Cog className="w-4 h-4 text-[#D4AF37]" />{v.transmission}</div>
          <div className="flex items-center gap-2"><Fuel className="w-4 h-4 text-[#D4AF37]" />{v.fuel_type}</div>
          <div className="flex items-center gap-2"><Snowflake className="w-4 h-4 text-[#D4AF37]" />{v.air_conditioning ? "A/C" : "No A/C"}</div>
        </div>
        <Link to={`/vehicle/${v.id}`} data-testid={`vehicle-book-${v.id}`}
          className="btn-gold mt-6 justify-center">Book Now</Link>
      </div>
    </div>
  );
}
